import {useEffect,useRef,useState,useContext} from "react"
import FloatingContext from "../contexts/FloatingContext"
import useApi from "../hooks/useApi"
import useFloating from "../hooks/useFloating"
import ButtonAction from "../commons/ButtonAction"
import Dropdown from "../commons/Dropdown"
import SwitchButton from "../commons/SwitchButton"
import close from "../assets/close-pink.svg"

export default function SubscribersFilters(){

    const {manageFloating,floatingReady}=useFloating()
    const [floatingContext]=useContext(FloatingContext)
    const requestApi=useApi()
    const value=floatingContext.value
    const setValue=floatingContext.setValue

    const filter1=useRef()
    const filter2=useRef()
    const filter3=useRef()
    const filter4=useRef()
    const filter5=useRef()
    const filter6=useRef()
    const filter7=useRef()
    const [filter1Val,setFilter1Val]=useState("")
    const [filter2Val,setFilter2Val]=useState("")
    const [filter3Val,setFilter3Val]=useState("")
    const [filter4Val,setFilter4Val]=useState("")
    const [filter5Val,setFilter5Val]=useState([])
    const [filter6Val,setFilter6Val]=useState([])
    const [filter7Val,setFilter7Val]=useState([])

    const [cityOptions,setCityOptions]=useState([])
    const [regionOptions,setRegionOptions]=useState([])
    const [countryOptions,setCountryOptions]=useState([])

    const loadCities=()=>{
        return new Promise(function(resolve){
            resolve(
                requestApi("general/cities",{context:"subscribers"})
                    .then(data=>{
                        let newOptions=[]
                        data.items.forEach(function(city){
                            newOptions.push({label:city.name,value:city.name})
                        })
                        return newOptions
                    })
            )
        })
    }

    const loadRegions=()=>{
        return new Promise(function(resolve){
            resolve(
                requestApi("general/regions",{context:"subscribers"})
                    .then(data=>{
                        let newOptions=[]
                        data.items.forEach(function(region){
                            newOptions.push({label:region.name,value:region.name})
                        })
                        return newOptions
                    })
            )
        })
    }

    const loadCountries=()=>{
        return new Promise(function(resolve){
            resolve(
                requestApi("general/countries",{context:"subscribers"})
                    .then(data=>{
                        let newOptions=[]
                        data.items.forEach(function(country){
                            newOptions.push({label:country.name,value:country.name})
                        })
                        return newOptions
                    })
            )
        })
    }

    useEffect(()=>{
        floatingReady(0)
        Promise.all([loadCities,loadRegions,loadCountries].map(func=>func())).then((result)=>{
            setCityOptions(result[0])
            setRegionOptions(result[1])
            setCountryOptions(result[2])
            floatingReady(1)
        })
    },[])

    const apply=()=>{
        let filter5List=[]
        if(filter5.current.getValue()){
            filter5.current.getValue().forEach(function(item){
                filter5List.push(item["value"])
            })
        }
        let filter6List=[]
        if(filter6.current.getValue()){
            filter6.current.getValue().forEach(function(item){
                filter6List.push(item["value"])
            })
        }
        let filter7List=[]
        if(filter7.current.getValue()){
            filter7.current.getValue().forEach(function(item){
                filter7List.push(item["value"])
            })
        }
        setValue({
            status:filter1Val,
            created:filter2.current.getValue()[0]?filter2.current.getValue()[0].value:"",
            month:filter3.current.getValue()[0]?filter3.current.getValue()[0].value:"",
            year:filter4.current.getValue()[0]?filter4.current.getValue()[0].value:"",
            city:filter5List,
            region:filter6List,
            country:filter7List
        })
        manageFloating("hide")
    }

    const clear=()=>{
        setFilter1Val("")
        setFilter2Val("")
        setFilter3Val("")
        setFilter4Val("")
        setFilter5Val([])
        setFilter6Val([])
        setFilter7Val([])
        filter2.current.setValue("")
        filter3.current.setValue("")
        filter4.current.setValue("")
        filter5.current.setValue("")
        filter6.current.setValue("")
        filter7.current.setValue("")
        setValue("")
        manageFloating("hide")
    }

    useEffect(()=>{
        if(filter2Val!="" && filter2Val!=undefined){
            restrict("period")
        }
    },[filter2Val])

    useEffect(()=>{
        if((filter3Val!="" && filter3Val!=undefined) || (filter4Val!="" && filter4Val!=undefined)){
            restrict("month_year")
        }
    },[filter3Val])

    useEffect(()=>{
        if((filter3Val!="" && filter3Val!=undefined) || (filter4Val!="" && filter4Val!=undefined)){
            restrict("month_year")
        }
    },[filter4Val])

    const restrict=(filter)=>{
        if(filter=="period"){
            setFilter3Val("")
            filter3.current.setValue("")
            setFilter4Val("")
            filter4.current.setValue("")
        }else if(filter=="month_year"){
            setFilter2Val("")
            filter2.current.setValue("")
        }
    }

    useEffect(()=>{
        if(value!=""){
            if(value["status"]!=""){
                setFilter1Val(value["status"])
            }
            if(value["created"]!=""){
                filter2.current.props["options"].forEach(function(item){
                    if(value["created"]==item.value){
                        filter2.current.setValue({label:item.label,value:item.value})
                    }
                })
            }
            if(value["month"]!=""){
                filter3.current.props["options"].forEach(function(item){
                    if(value["month"]==item.value){
                        filter3.current.setValue({label:item.label,value:item.value})
                    }
                })
            }
            if(value["year"]!=""){
                filter4.current.props["options"].forEach(function(item){
                    if(value["year"]==item.value){
                        filter4.current.setValue({label:item.label,value:item.value})
                    }
                })
            }
        }
    },[value])

    useEffect(()=>{
        if(value){
            if(value["city"].length>0){
                let newValue=[];
                filter5.current.props["options"].forEach(function(item){
                    if(value["city"].includes(item.value)){
                        newValue.push({label:item.label,value:item.value})
                    }
                })
                filter5.current.setValue(newValue)
            }
        }
    },[cityOptions])

    useEffect(()=>{
        if(value){
            if(value["region"].length>0){
                let newValue=[];
                filter6.current.props["options"].forEach(function(item){
                    if(value["region"].includes(item.value)){
                        newValue.push({label:item.label,value:item.value})
                    }
                })
                filter6.current.setValue(newValue)
            }
        }
    },[regionOptions])

    useEffect(()=>{
        if(value){
            if(value["country"].length>0){
                let newValue=[];
                filter7.current.props["options"].forEach(function(item){
                    if(value["country"].includes(item.value)){
                        newValue.push({label:item.label,value:item.value})
                    }
                })
                filter7.current.setValue(newValue)
            }
        }
    },[countryOptions])

    return(
        <div className="floating-blocks">
            <div className="floating-close-frame">
                <div className="floating-close" onClick={()=>{manageFloating("hide")}}><img src={close} /></div>
            </div>
            <div className="floating-content">
                <div className="floating-options floating-options-space">
                    <div className="floating-half">
                        <SwitchButton ref={filter1} val={filter1Val} setVal={setFilter1Val} 
                            options={[
                                {label:"Activos",value:"active"},
                                {label:"Inactivos",value:"inactive"}
                        ]} />
                    </div>
                </div>
                <div className="floating-group">Fecha de registro</div>
                <div className="floating-options">
                    <div className="floating-full">
                        <Dropdown ref={filter2} val={filter2Val} setVal={setFilter2Val} placeholder="Período" multiple={0} searchable={0} options={[
                            {label:"Indiferente",value:""},
                            {label:"Última hora",value:"last_hour"},
                            {label:"Hoy",value:"today"},
                            {label:"Ayer",value:"yesterday"},
                            {label:"Última semana",value:"last_week"},
                            {label:"Últimos quince días",value:"last_15_days"},
                            {label:"Este mes",value:"this_month"},
                            {label:"Últimos tres meses",value:"last_three_months"},
                            {label:"Últimos seis meses",value:"last_six_months"},
                            {label:"Este año",value:"this_year"}
                        ]} />
                    </div>
                    <div className="floating-half" >
                        <Dropdown ref={filter3} val={filter3Val} setVal={setFilter3Val} placeholder="Mes" multiple={0} searchable={0} options={[
                            {label:"Todos",value:""},
                            {label:"Enero",value:"01"},
                            {label:"Febrero",value:"02"},
                            {label:"Marzo",value:"03"},
                            {label:"Abril",value:"04"},
                            {label:"Mayo",value:"05"},
                            {label:"Junio",value:"06"},
                            {label:"Julio",value:"07"},
                            {label:"Agosto",value:"08"},
                            {label:"Septiembre",value:"09"},
                            {label:"Octubre",value:"10"},
                            {label:"Noviembre",value:"11"},
                            {label:"Diciembre",value:"12"}
                        ]} />
                        <Dropdown ref={filter4} val={filter4Val} setVal={setFilter4Val} placeholder="Año" multiple={0} searchable={0} options={[
                            {label:"Todos",value:""},
                            {label:"2022",value:"2022"},
                            {label:"2023",value:"2023"},
                            {label:"2024",value:"2024"},
                            {label:"2025",value:"2025"},
                            {label:"2026",value:"2026"},
                            {label:"2027",value:"2027"},
                            {label:"2028",value:"2028"},
                            {label:"2029",value:"2029"},
                            {label:"2030",value:"2030"},
                            {label:"2031",value:"2031"},
                            {label:"2032",value:"2032"},
                            {label:"2033",value:"2033"},
                            {label:"2034",value:"2034"},
                            {label:"2034",value:"2034"}
                        ]} />
                    </div>
                </div>
                <div className="floating-group">Ubicación</div>
                <div className="floating-options">
                    <div className="floating-full">
                        <Dropdown ref={filter5} val={filter5Val} setVal={setFilter5Val} placeholder="Ciudad" multiple={1} searchable={0} options={cityOptions} />
                        <Dropdown ref={filter6} val={filter6Val} setVal={setFilter6Val} placeholder="Provincia" multiple={1} searchable={0} options={regionOptions} />
                        <Dropdown ref={filter7} val={filter7Val} setVal={setFilter7Val} placeholder="País" multiple={1} searchable={0} options={countryOptions} />
                    </div>
                </div>
            </div>
            <div className="floating-actions">
                <ButtonAction label="Resetear" color="pink" clickEvent={clear} />
                <ButtonAction label="Aplicar" color="purple" clickEvent={apply} />
            </div>
        </div>
    )
    
}